import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import { Sizes, Typography } from '@ratehub/base-ui';
import { ContributionLimitRRSPCalculator } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';
import AdvertisingDisclosure from './AdvertisingDisclosure';


function BankingContributionLimitRRSPCalc({
    disclaimer,
    showAdDisclosure,
    className,

    ...otherProps
}) {
    return (
        <Container className={className}>
            <ContributionLimitRRSPCalculator
                {...otherProps}
            />

            <If condition={disclaimer}>
                <p className={
                    classNames(
                        Typography.CLASSES.TEXT_XS,
                        'disclaimer',
                    )}
                >
                    {disclaimer}
                </p>
            </If>

            <If condition={showAdDisclosure}>
                <AdvertisingDisclosure
                    className="adDisclosure"
                    size="extra-small"
                />
            </If>
        </Container>
    );
}

BankingContributionLimitRRSPCalc.propTypes = {
    showAdDisclosure: PropTypes.bool,
    disclaimer: PropTypes.string,
    className: PropTypes.string,
};

BankingContributionLimitRRSPCalc.defaultProps = {
    showAdDisclosure: undefined,
    disclaimer: undefined,
    className: undefined,
};

const CONTAINER_MAX_WIDTH = '50rem';

const Container = styled.section`
    padding: ${Sizes.SPACING.HALF} 0;
    max-width: ${CONTAINER_MAX_WIDTH};
    margin: 0 auto;

    > .adDisclosure {
        display: block;

        max-width: ${CONTAINER_MAX_WIDTH};
        margin: ${Sizes.SPACING.ONE} 0 0 auto;
    }

    > .disclaimer {
        margin: 0;
        text-align: center;

        padding-top: ${Sizes.SPACING.HALF};
    }
`;

BankingContributionLimitRRSPCalc.blockKey = 'rh/banking-rrsp-contribution-room-calculator';
BankingContributionLimitRRSPCalc.requiresLayoutRow = true;
BankingContributionLimitRRSPCalc.hasHeading = false;
BankingContributionLimitRRSPCalc.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsBanking ];

export default BankingContributionLimitRRSPCalc;
